import _request from '@/utils/request.js'

var _channel = {
    // 根据渠道标识获取渠道信息
    getChannelInfo (query, resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/channel/info"),
            data  : query,
            method  : 'post',
            success : resolve,
            error   : reject
        })
    },
}

export default _channel